import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # Accnt
 *
 * Accnt을 설명하세요.
 */
export const Accnt = types
  .model('Accnt')
  // --------------------------------------------------------------------------
  .props({
    accntSid: types.identifierNumber,
    accntId: types.optional(types.string, ''), // 계정
    vmVal: types.maybeNull(types.number), // VM
    fipVal: types.maybeNull(types.number), // FIP
    snapshotVal: types.maybeNull(types.number), // 스냅샷
    imageVal: types.maybeNull(types.number), // 이미지
    storageVal: types.maybeNull(types.number), // 스토리지
    inBndVal: types.maybeNull(types.string), // 공인 InBound
    outBndVal: types.maybeNull(types.string), // 공인 OutBound

    useYn: types.optional(types.string, 'Y'),
    delYn: types.optional(types.string, 'N'),

    insertDt: types.optional(types.number, 0),
    updateDt: types.optional(types.number, 0),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model accnt --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: IAccnt }) => {
      const newProps = { ...self, ...props } as IAccnt;
      (Object.keys(newProps) as TAccntKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TAccnt = Instance<typeof Accnt>;
type TAccntSnapshot = SnapshotOut<typeof Accnt>;

export interface IAccnt extends TAccnt {}
export type TAccntKeys = keyof TAccntSnapshot & string;
export interface IAccntSnapshot extends TAccntSnapshot {}
export const createAccnt = () => types.optional(Accnt, {} as TAccnt);
